/* global $, jQuery, google, stockAjax*/
'use strict';
(function ($) {

$(document).on('click', '.js-images-toggle', function (e) {
	e.preventDefault(),
	$('.js-images-toggle').toggleClass( 'js-images--show' );
	$('.js-term__image_wrap').toggleClass( 'images--hide' );
});


function reset_image_toggle() {

	$('.js-images-toggle').addClass( 'js-images--show' );

	$( '.js-images-toggle .images-show .js-image-count' ).html( '' );

}
function lightenTable(c,s) {
	$('#stock_results').css('backgroundColor','hsl('+ c+ ', ' + s +'%, 74%)');
	setTimeout(function(){
		$('#stock_results').css('backgroundColor','rgba(0,0,0,0)');
	}, 300);
}

function search_term() {

	mcs_triggerSpinner();
	reset_image_toggle();
	var term__text = jQuery("#term__text").val();
	var client_code = jQuery("#client__code").val();
	var client_id = jQuery("#client__id").val();
	var post_data = {
		action: 'get_search_results',
		search_term: term__text,
		client_code: client_code,
		client_id: client_id,
		getterms_nonce: mcs_data.gettermsNonce
	};
	if ( term__text === '' ) {

		mcs_hideSpinner();
		return;
	}
	$('#term__body').empty();

	jQuery.post( mcs_data.ajax_url, post_data , function(response) {
		var term__body = {};
		var term__body = document.getElementById("term__body");
		if ( response === '' ||
			response === 0 ||
			( response.success !== undefined && ! response.success ) ||
			response.length == 0 ) {

			term__body.textContent = '';
			mcs_hideSpinner();
			lightenTable(0,100); // red
			return;
		}

		term__body.textContent = '';
		const main_list = response.main;
		var div__results = document.createElement( 'div' );
		div__results.className = 'row product__results';

		var div__row = document.createElement( 'div' );
		div__row.className = 'row product__line';
		if ( response.main === undefined ) {

			term__body.textContent = '';
			mcs_hideSpinner();
			lightenTable(0,100); // red
			return;
		}

		// render main product list
		div__row.appendChild( build_main( response.main ) );


		if ( typeof response.cdu != 'undefined' ) {
			div__row.appendChild( build_xrefs( response.cdu ) );
		}

		div__results.appendChild( div__row );
		if ( typeof response.oe != 'undefined' && ( response.oe.length > 0 || Object.keys(response.oe).length )  ) {
			var contains_span_stk = document.createElement("h3"),
			content_stk = document.createTextNode( 'See Also' );
			contains_span_stk.appendChild(content_stk);
			div__row.appendChild( contains_span_stk );
			div__row.appendChild( build_oe_ref_listing( response.oe ) );
		}

		term__body.appendChild( div__results );

		const image_count = jQuery( "#term__body img").length;
		$( '.js-images-toggle .images-show .js-image-count' ).html( '[ ' + image_count + ' ]' );
		apply_modal_events();

	}, 'json')
	.fail(function( e ) {
		mcs_hideSpinner();
	})
	.always( function(){
		mcs_hideSpinner();
	});
}

function public_search_term() {

	mcs_triggerSpinner();
	reset_image_toggle();
	var term__text = jQuery("#term__public_text").val();
	var post_data = {
		action: 'get_public_search_results',
		search_term: term__text,
		getterms_nonce: mcs_data.gettermsNonce
	};
	if ( term__text === '' ) {

		mcs_hideSpinner();
		return;
	}
	$('#term__body').empty();

	jQuery.post( mcs_data.ajax_url, post_data , function(response) {
		var term__body = {};
		var term__body = document.getElementById("term__body");
		if ( response === '' ||
			response === 0 ||
			( response.success !== undefined && ! response.success ) ||
			response.length == 0 ) {

			term__body.textContent = '';
			mcs_hideSpinner();
			lightenTable(0,100); // red
			return;
		}

		term__body.textContent = '';
		const main_list = response.main;
		var div__results = document.createElement( 'div' );
		div__results.className = 'row product__results';

		var div__row = document.createElement( 'div' );
		div__row.className = 'row product__line';
		//var main_result = response.shift();
		if ( response.main === undefined ) {

			term__body.textContent = '';
			mcs_hideSpinner();
			lightenTable(0,100); // red
			return;
		}
		// render main product list
		div__row.appendChild( build_main( response.main ) );


		if ( typeof response.cdu != 'undefined' ) {
			div__row.appendChild( build_xrefs( response.cdu ) );
		}

		div__results.appendChild( div__row );
		if ( typeof response.oe != 'undefined' && ( response.oe.length > 0 || Object.keys(response.oe).length )  ) {
			var contains_span_stk = document.createElement("h3"),
			content_stk = document.createTextNode( 'See Also' );
			contains_span_stk.appendChild(content_stk);
			div__row.appendChild( contains_span_stk );
			div__row.appendChild( build_oe_ref_listing( response.oe ) );
		}

		term__body.appendChild( div__results );

		const image_count = jQuery( "#term__body img").length;
		$( '.js-images-toggle .images-show .js-image-count' ).html( '[ ' + image_count + ' ]' );
		apply_modal_events();

	}, 'json')
	.fail(function( e ) {
		console.debug( e );
		mcs_hideSpinner();
	})
	.always( function(){
		mcs_hideSpinner();
	});
}

jQuery(document).ready(function() {

	jQuery(window).keydown(function(event){

		if(event.keyCode === 13) {
			if( document.getElementById("term__text") === document.activeElement ) {
				event.preventDefault();
				search_term();

				return false;
			}
		}
		if(event.keyCode === 13) {
			if( document.getElementById("term__public_text") === document.activeElement ) {
				event.preventDefault();
				public_search_term();

				return false;
			}
		}
	});
	if ( document.getElementById("term__text") != null ) {
		document.getElementById("term__text").focus();
	}
});

}(jQuery));


function build_order_btn( qt_int, stock_reserved, product_ref, product_name, pvp, discount, price_discounted, size, qt_transit ) {

	// 4.0 create element
	var col__order_button = document.createElement( 'button' );
	var contains_stk = '';
	var contains_stk_class = '';

	var qt_ttl       = false;
	var qty_add_cart = false;
	const term__qt   = 1;

	var btn_class = '';
	if ( size === 'small' ) {
		btn_class = ' btn-sm';
	}
	// 3.1 calculate stock
	// 3.1.1 calculate remainder after reserved
	if ( null !== stock_reserved ){
		var stock_class_base = 'term__avail btn glyphicon ';
		var qt_res = stock_reserved;
		if ( typeof qt_res === 'string' ) {
			qt_res = stock_reserved.replace( ',', '.' )
		}

		qt_ttl = qt_int - qt_res;
		if ( ~~qt_ttl >= ~~term__qt && ~~qt_int >= ~~term__qt ) { // binary compare
			contains_stk_class = 'glyphicon-ok btn-success' + btn_class;
			qty_add_cart = true;
		} else if ( ~~qt_ttl < ~~term__qt && ~~qt_int >= ~~term__qt ) { // total less than 1 and there's more than reserved
			qty_add_cart = false;
			contains_stk_class = 'glyphicon-question-sign btn-warning' + btn_class;
		} else if ( ~~qt_ttl < ~~term__qt && ~~qt_int < ~~term__qt && qt_transit >= term__qt ) { // total less than 1, there's less than reserved, but! there's more on the way
			qty_add_cart = false;
			contains_stk_class = 'glyphicon-question-sign btn-info' + btn_class;
		} else if ( ~~qt_ttl < ~~term__qt && ~~qt_int < ~~term__qt && qt_transit < term__qt ) { // total less than 1, and there's less than reserved
			qty_add_cart = false;
			contains_stk_class = 'glyphicon-question-sign btn-danger' + btn_class;
		}
	} else { // 3.1.2 no reserved orders
		if ( ~~qt_int > ~~term__qt ) { // binary compare: there's more in stock than requested
			qty_add_cart = true;
			contains_stk_class = 'glyphicon-ok btn-success' + btn_class;
		} else if ( ~~qt_int === ~~term__qt ) { // its the last one
			qty_add_cart = false;
			contains_stk_class = 'glyphicon-question-sign btn-warning' + btn_class;
		} else if ( ~~qt_int < ~~term__qt && qt_transit >= term__qt ) { // there's none, but! more are in transit
			qty_add_cart = false;
			contains_stk_class = 'glyphicon-question-sign btn-danger' + btn_class;
		} else if ( ~~qt_int < ~~term__qt && qt_transit < term__qt ) { // there's none, and! there's none in transit
			qty_add_cart = false;
			contains_stk_class = 'glyphicon-question-sign btn-danger' + btn_class;
		}
	}

	// 3.2 create button
	var contains_span_stk = document.createElement("span"),
	content_stk = document.createTextNode( contains_stk );
	contains_span_stk.className = stock_class_base + contains_stk_class;
	contains_span_stk.appendChild(content_stk);

	// if there's at least one item
	if( qty_add_cart ) {
		var add_to_cart_text = document.createTextNode( mcs_data.addToOrder );
		col__order_button.appendChild(add_to_cart_text);
		col__order_button.className = "term__cart product__add-button term--available js-add__cart";
	} else { // request info
		if ( qt_transit < term__qt ) {
			var add_to_cart_text = document.createTextNode( mcs_data.getDeliveryDate );

			col__order_button.className = "term__cart product__add-button term--not-available js-add__cart js-ask-avail";
			col__order_button.appendChild(add_to_cart_text);
		} else {
			var add_to_cart_text = document.createTextNode( mcs_data.inTransit );

			col__order_button.className = "term__cart product__add-button term--in-transit js-add__cart js-ask-avail";
			col__order_button.appendChild(add_to_cart_text);
		}
	}

	col__order_button.dataset.product_sku = product_ref;
	col__order_button.dataset.product_name = product_name;
	col__order_button.dataset.product_pvp = pvp;
	col__order_button.dataset.product_discount = discount;
	col__order_button.dataset.price_discounted = price_discounted;

	col__order_button.appendChild(contains_span_stk);

	return col__order_button;
}

function isNumeric(e) {
	var specialKeys = [];
	specialKeys.push(8); //Backspace
	specialKeys.push(13); //enter
	specialKeys.push(46); //delete
	var keyCode = e.which ? e.which : e.keyCode,
		ret = (( keyCode <= 57) || specialKeys.indexOf(keyCode) !== -1);
	document.getElementById("error").style.display = ret ? "none" : "inline";
	return ret;
}

function build_image( image_url ) {

	const classname = 'term__image_wrap js-term__image_wrap images--hide';
	var d__wrp = document.createElement("div");
	d__wrp.className = classname;

	if ( image_url) {
		var img_el = document.createElement( 'img' );
		img_el.src = image_url;
		img_el.className= 'term__image js-images-modal--trigger';
		d__wrp.appendChild(img_el);
	}


	return d__wrp;
}

function build_header( header ) {

	const classname = 'product__wrap';

	var contains_span_ref = document.createElement( 'span' );
	var content_ref = document.createTextNode( header );
	contains_span_ref.className= 'term__vendor';
	contains_span_ref.appendChild( content_ref );
	var d__wrp = document.createElement("div");
	d__wrp.className = classname;

	d__wrp.appendChild(contains_span_ref);

	return d__wrp;
}
function build_main( main ){

	const classname = 'product__wrap product__found';
	var term__bodyfrag = document.createDocumentFragment();
	main.forEach( function( result ) {
		if ( result.product === undefined ) {
			return;
		}
		term__bodyfrag.appendChild( build_image( result.image ) );
		term__bodyfrag.appendChild( build_line( result.product, classname ) );
	});



	return term__bodyfrag;
}
function build_oe_ref_listing( oe ) {
	var term__bodyfrag = document.createDocumentFragment();
	const classname = 'product__wrap product__equivalence';
	for (var key in oe) {
		if (oe.hasOwnProperty(key)) {
			var mains = oe[key];

			term__bodyfrag.appendChild( build_xrefs( mains ) );

		}
	}

	return term__bodyfrag;
}

function build_xrefs(xrefs) {
	const classname = 'product__wrap product__equivalence';
	var term__bodyfrag = document.createDocumentFragment();

	for (var key in xrefs) {
		if (xrefs.hasOwnProperty(key)) {
			var mains = xrefs[key];
			mains.forEach(function(result) {
				if (result.product === undefined) {
					return;
				}

				term__bodyfrag.appendChild(build_image(result.image));
				term__bodyfrag.appendChild(build_line(result.product, classname));
			});
		}
	}

	return term__bodyfrag;
}

function build_line ( product, classname ) {
	// no repaints
	var term__bodyfrag = document.createDocumentFragment();

	var d__wrp       = document.createElement("div");
	d__wrp.className = classname;

	var d__inn       = document.createElement("div");
	d__inn.className = "product__inner--line";

	// add columns
	/** e = [
	 *  0: vendor_name
	 *  1: vendor_ref,
	 *  2: price_formatted,
	 *  3: qty,
	 *  4: discount letter, discount_class
	 *  5: reserved,
	 *  6: discount_value ----
	 *  7: product_name   ----
	 *  8: discounted value
	 *  9: transit
	 * 10: oe_ref
	 * ]
	 */

	// 1 - brand
	var brand_col = build_brand( product.vendor_ref, product.oe_ref, product.discount_class, product.vendor_name );
	d__inn.appendChild( brand_col );

	// 2 - reference
	var ref_col = build_reference( product.product_name, product.vendor_ref );
	d__inn.appendChild( ref_col );

	// 3 - price
	var php_col = build_pvp( product.price_formatted, product.discount_value, product.discount_price );
	d__inn.appendChild( php_col );

	// 4 - order button
	var order_btn = build_order_btn( product.product_qty, product.product_reserved, product.vendor_ref, product.product_name, product.price_formatted, product.discount_value, product.discount_price, 'small', product.product_transit );
	d__inn.appendChild( order_btn );

	// add to wrapper element
	d__wrp.appendChild( d__inn );

	// add overlay
	var overlay = build_overlay();
	d__wrp.appendChild( overlay );

	// add to fragment
	term__bodyfrag.appendChild( d__wrp );

	return term__bodyfrag;

}

function build_brand( ref, oe_ref, discount_letter, brand ) {


	// 2.0 create element
	var col__ref = document.createElement( 'p' );
	col__ref.className = 'term__data term__ref__data';

	// 2.1 add ref
	var contains_span_ref = document.createElement( 'span' );
	var content_ref = document.createTextNode( ref );
	contains_span_ref.className= 'term__text__query';
	contains_span_ref.appendChild( content_ref );

	col__ref.appendChild(contains_span_ref);

	// 2.2 add discount letter
	var content_span_ref_letter = '';
	if ( discount_letter !== '' ) {

		const discount_letter_text = ' (' + discount_letter + ')';

		var content_text_ref_letter = document.createTextNode( discount_letter_text ),
		content_span_ref_letter = document.createElement( 'span' );

		content_span_ref_letter.appendChild(content_text_ref_letter);
		content_span_ref_letter.className= 'term__letter info--unselectable';

		col__ref.appendChild(content_span_ref_letter);
	}

	// 2.3 oe ref
	var content_text_ref_vendor = document.createTextNode( oe_ref ),
	content_span_ref_vendor = document.createElement( 'span' );
	content_span_ref_vendor.className = 'term__oe_ref';
	content_span_ref_vendor.appendChild( content_text_ref_vendor );

	col__ref.appendChild(content_span_ref_vendor);

	// 2.4 vendor name
	var content_text_ref_vendor = document.createTextNode( brand ),
	content_span_ref_vendor = document.createElement( 'span' );
	content_span_ref_vendor.className = 'term__vendor';
	content_span_ref_vendor.appendChild( content_text_ref_vendor );

	col__ref.appendChild(content_span_ref_vendor);
	return col__ref;
}


function build_reference( description, ref ) {

	// 2.0 create element
	var col__ref = document.createElement( 'p' );
	col__ref.className = 'term__data term__description';

	// 2.1 add description
	var content_text_description = document.createTextNode( description ),
	content_text_description_block = document.createElement('span');
	content_text_description_block.appendChild(content_text_description);
	content_text_description_block.className= "term__description";
	col__ref.appendChild(content_text_description_block);

	// link to read more
	var content_text_read_more = document.createTextNode( 'See details' ),
	content_text_read_more_link = document.createElement('a');
	content_text_read_more_link.appendChild(content_text_read_more);

	content_text_read_more_link.className = 'term__read_more has-non-brand-bottom-border';
	content_text_read_more_link.title = 'See more details';
	content_text_read_more_link.href = '/stock/product/' + ref;
	col__ref.appendChild(content_text_read_more_link);
	return col__ref;
}

function build_pvp( pvp, discount, price_discounted ) {

	var contains_pvp = '';
	if ( pvp === "" ) {
		contains_pvp = "-";
	} else {
		contains_pvp = pvp;
	}

	// 3.0 create element
	var contains_span_pvp = document.createElement("span");
	contains_span_pvp.className= "term__text__pvp";


	// 3.1 add pvp
	var content_pvp = document.createTextNode(contains_pvp);
	contains_span_pvp.appendChild(content_pvp);


	// 3.2 add audience
	var content_text_price_audience = document.createTextNode('( ' + mcs_data.rP + ')'),
	content_span_price_audience = document.createElement('span');

	content_span_price_audience.appendChild(content_text_price_audience);
	content_span_price_audience.className= "term__audience";
	contains_span_pvp.appendChild(content_span_price_audience);

	/* 3.3 discount value */
	var discount_value = '';
	if( discount !== '' ) {
		discount_value += discount + '% : ' + price_discounted;
	}
	var content_text_ref_discount = document.createTextNode( discount_value ),
		content_span_ref_discount = document.createElement("span");
	content_span_ref_discount.appendChild(content_text_ref_discount);
	content_span_ref_discount.className = "term__discount";
	contains_span_pvp.appendChild(content_span_ref_discount);


	// return col
	return contains_span_pvp;
}

function build_overlay() {
	var d__ovl = document.createElement("div"),
	h__msg = document.createElement("h2"),
	i__chk = document.createElement("i");

	d__ovl.className = "product__overlay js-product__overlay";
	h__msg.className = "product__overlay__title";
	i__chk.className = "glyphicon glyphicon-ok btn btn-success";
	// div.product_overlay has h2 and i
	var h__msg_text = document.createTextNode( mcs_data.addedToOrder );
	h__msg.appendChild(h__msg_text);
	d__ovl.appendChild(h__msg);
	d__ovl.appendChild(i__chk);

	return d__ovl;
}
function apply_modal_events(){

	var modal = document.querySelector('.js-images-modal');

	// Get the modal image and caption elements
	var modalImg = modal.querySelector('.js-images-modal-img');

	// When the user clicks on the thumbnail, open the modal and display the image
	document.querySelectorAll('.js-images-modal--trigger').forEach(function(thumbnail) {
		thumbnail.addEventListener('click', function() {
			modal.style.display = "block";
			modalImg.src = this.src;
		});
	});

	// When the user clicks on <span> (x), close the modal
	modal.querySelector('.modal-close').addEventListener('click', function() {
		modal.style.display = "none";
	});

}